import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import ContentCreatorSection from '../components/contentCreatorSection';
import Layout from '../components/layout';
import OhCleoTeam from '../components/ohCleoTeam';
import HeaderAbout from '../components/headerAbout';
import OhCleoStory from '../components/ohCleoStory';
import styles from './about.module.css';

const About = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulWebpageSection {
          edges {
            node {
              childContentfulWebpageSectionContentJsonNode {
                overline
                title
                subTitle
                body1
                body2
              }
              contentfulid
              series {
                coverImage {
                  fluid(maxWidth: 300, resizingBehavior: FILL) {
                    ...GatsbyContentfulFluid
                  }
                }
              }
              images {
                fluid(maxWidth: 580, resizingBehavior: FILL) {
                  ...GatsbyContentfulFluid
                }
                description
                title
              }
            }
          }
        }
      }
    `,
  );

  const sections = data.allContentfulWebpageSection.edges.reduce((all, one) => {
    const newAll = { ...all };
    newAll[one.node.contentfulid] = {
      ...one.node.childContentfulWebpageSectionContentJsonNode,
      series: one.node.series ? one.node.series : undefined,
      images: one.node.images ? one.node.images : undefined,
    };
    return newAll;
  }, {});
  return (
    <Layout title="About OhCleo" showBecomeContentCreator={true}
    showTransparentNav={false}>
      <div className={styles.aboutWrapper}>
        <HeaderAbout section={sections.sectionHeaderAbout} />
        <OhCleoStory section={sections.sectionOhCleoStory} />
        {/* <OhCleoTeam /> */}
        <ContentCreatorSection
          section={sections.sectionContentCreatorAbout}
          imagesSeries={sections.sectionWelcomeContentCreators.series}
        />
      </div>
    </Layout>
  );
};

export default About;
